import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { type FC, type PropsWithChildren, useState } from 'react';
import { useOutsideClickRef } from 'rooks';
import DropdownPanel from '../0100_dropdown_panel';
import Tab, { type IProps as ITabProps } from '../0200_tab';

interface IProps extends ITabProps {
  forceDropdown?: boolean;
  compactModeLabelStyle?: 'justify-end' | 'justify-between';
}

const ResponsiveTabGroup: FC<PropsWithChildren<IProps>> = ({
  label,
  children,
  forceDropdown,
  compactModeLabelStyle = 'justify-end',
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [ref] = useOutsideClickRef(() => setIsExpanded(false));

  return (
    <>
      <div
        ref={ref}
        role="button"
        tabIndex={0}
        className={clsx('block z-20', !forceDropdown && 'lg:hidden')}
        onClick={() => {
          setIsExpanded(x => !x);
        }}
        onKeyDown={() => setIsExpanded(x => !x)}
      >
        <div className="flex justify-end w-48">
          <Tab
            className={clsx('flex mt-1', compactModeLabelStyle)}
            label={
              <>
                <span className="pr-2">{label}</span>
                <FontAwesomeIcon
                  icon={faCaretDown}
                  className={clsx(
                    '-mt-1 origin-center transition-transform duration-300',
                    isExpanded ? '-scale-y-100' : 'rotate-0',
                  )}
                />
              </>
            }
          />
        </div>

        <div className="absolute">
          <DropdownPanel isExpanded={isExpanded} className="w-48">
            {children}
          </DropdownPanel>
        </div>
      </div>
      <div className={clsx('hidden', !forceDropdown && 'lg:flex')}>
        {children}
      </div>
    </>
  );
};

export default ResponsiveTabGroup;
